import styled, { css } from 'styled-components';
import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

type PricesWrapperProps = {
  $size?: 'large' | 'small';
  $inline?: boolean;
};

export const PricesWrapper = styled.div<PricesWrapperProps>`
  display: flex;
  gap: ${size(0.25)};
  flex-direction: column;
  align-items: flex-start;

  ${({ $inline }) =>
    $inline &&
    css`
      gap: 0px;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;

      ${SellingPrice} {
        margin-right: 8px;
        margin-bottom: 2px;
      }

      ${ReferencePrice} {
        margin-right: 8px;
      }
    `}

  ${({ $size }) =>
    $size === 'small' &&
    css`
      ${SellingPrice} {
        font-size: 0.875rem;

        ${theme.screens.Sm} {
          font-size: 1.125rem;
        }
      }

      ${ReferencePrice} {
        font-size: 0.75rem;

        ${theme.screens.Sm} {
          font-size: 0.875rem;
        }
      }

      ${OriginalTotal} {
        font-size: 0.75rem;

        ${theme.screens.Sm} {
          font-size: 0.875rem;
        }
      }
    `}

  ${({ $size }) =>
    $size === 'large' &&
    css`
      ${SellingPrice} {
        font-size: 1.25rem;

        ${theme.screens.Sm} {
          font-size: 1.5rem;
        }
      }

      ${ReferencePrice} {
        font-size: 1rem;

        ${theme.screens.Sm} {
          font-size: 1.125rem;
        }
      }

      ${OriginalTotal} {
        font-size: 1rem;

        ${theme.screens.Sm} {
          font-size: 1.125rem;
        }
      }
    `}
`;

type SellingPriceProps = {
  $priceDesign?: TPriceDesign | null;
  $discount?: boolean;
};

export const SellingPrice = styled.div<SellingPriceProps>`
  font-weight: 700;
  line-height: 1.2;
  font-size: 1rem;

  ${theme.screens.Sm} {
    font-size: 1.25rem;
    letter-spacing: -0.02em;
  }

  ${({ $priceDesign }) =>
    $priceDesign && priceDesignStyles($priceDesign.backgroundColor, $priceDesign.textColor)}

  ${({ $priceDesign, $discount }) =>
    $discount &&
    !$priceDesign &&
    css`
      color: ${theme.colors.text.highlight};
    `}
`;

const priceDesignStyles = (backgroundColor: string | null, textColor: string) => css`
  display: inline-flex;
  border-radius: 8px;
  padding: ${backgroundColor && '2px 8px'};
  background-color: ${backgroundColor};
  color: ${textColor};
`;

export const ReferencePrice = styled.div`
  font-weight: 400;
  line-height: 1.2;
  font-size: 0.75rem;
  color: ${theme.colors.text.alt};

  ${theme.screens.Sm} {
    font-size: 1rem;
    letter-spacing: -0.02em;
  }
`;

export const OriginalTotal = styled.div`
  font-weight: 400;
  line-height: 1.2;
  font-size: 0.875rem;
  color: ${theme.colors.text.alt};

  ${theme.screens.Sm} {
    font-size: 1rem;
    letter-spacing: -0.02em;
  }
`;

export const ProductPriceBadge = styled.div`
  margin-left: 8px;
`;
